import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import ScheduleProWrapper from '../../../SmartSchedule/SchedulePro/ScheduleProWrapper'
import TinyLoader from '../../../Common/TinyLoader/TinyLoader'
import { getUserSelector } from '../../../../../redux/reducers/reducerSlices/UserReducer'

const GBI_BASE_URL = process.env.REACT_APP_GBI_BASE_URL || 'https://ge-57f4cb1c5b7a4fd4886306daed78a255.ecs.us-west-2.on.aws/?theme=light'

const GenerativeBusinessIntelligence = (props) => {
  const [isLoading, setIsLoading] = useState(true)
  const { selectedWarehouse,cu_id } = useSelector(getUserSelector)
  const warehouseId = selectedWarehouse?.ID
  const GBI_URL = warehouseId ? `${GBI_BASE_URL}&userId=${cu_id}` : `${GBI_BASE_URL}&userId=${cu_id}`

  return (
    <ScheduleProWrapper>
      <div className='container-fluid m-1 createPo-wrapper-ss p-3' style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        {isLoading && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
            <TinyLoader />
          </div>
        )}
        <iframe
          src={GBI_URL}
          title='Generative Business Intelligence'
          onLoad={() => setIsLoading(false)}
          style={{
            flex: 1,
            width: '111.11%',
            border: 'none',
            display: isLoading ? 'none' : 'block',
            transform: 'scale(0.9)',
            transformOrigin: 'top left',
            height: '111.11%',
          }}
          allowFullScreen
        />
      </div>
    </ScheduleProWrapper>
  )
}

export default GenerativeBusinessIntelligence
